import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { IAgency } from 'src/app/shared/classes/agency';
import { CaseService } from '../../services/case.service';
import { UtilitiesService} from '../../services/utilities.service';
import { ApplicationAgentDto } from '../case/dto/application-agent.dto';
import { MessageService, Message } from 'primeng/api';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-case-agent',
  templateUrl: './case-agent.component.html'
})
export class CaseAgentComponent implements OnInit {

  @Input() caseId: string;
  @Output() changeEvent = new EventEmitter();

  agent: any; // ApplicationAgentDto;
  agencyList: IAgency[];
  cols: any[];
  bHasPrevAgent = false;

  constructor(private caseService: CaseService, private utilService: UtilitiesService, private messageService: MessageService,
              private cookieService: CookieService) { }

  ngOnInit() {
    this.agent = new ApplicationAgentDto().create();
    this.agencyList = [];  // initialize agency list (populated when doing searches)
    this.cols = [
      { field: 'id'},
      { field: 'name', header: 'Name' },
      { field: 'strAddr', header: 'Street Addr' },
      { field: 'city', header: 'City' },
      { field: 'state', header: 'State' },
      { field: 'phone', header: 'Phone' },
      { field: 'email', header: 'Email' },
    ];

    if (!this.caseId) {
      this.bHasPrevAgent = this.checkPrevAgent();
      return;
    }

    this.caseService.getCaseAgent(this.caseId).subscribe(data => {
      this.agent = data;
      this.dataChange();  // force an emit event, so the parent component can capture Agency data
    });
  }

    // this method executed whenever any data in the component is changed; it should trigger an event defined on the PARENT component
    dataChange() {
      this.utilService.doAudit(this.agent, 'agent data changed');
      this.changeEvent.emit(this.agent);
    }
    getLastAgency(): void {
      const userName = this.cookieService.get('userName');
      const obj = localStorage.getItem(userName + '-lastAgency');
      this.utilService.doAudit(obj, 'stringified agency obj:');
      if (obj) {
        this.agent = JSON.parse(obj);
        this.dataChange();  // emit the change
      }
    }

  getAgencyList() {
      this.agencyList = [];
      let xString = this.agent.name;
      xString = xString.replace(/[|&;$%@"<>()+.]/g, "");
      this.caseService.findAgency(xString).subscribe(data => {
        if (data) {
          this.agencyList = data;
          if (data.length < 1) {
            this.showToast({ key: 'toast', severity: 'info', detail: 'No matching Agency found!', summary: 'Info' });
          }
        }
        return;
      });
    }

    agencySelected(item) {
      this.agent.name = item.name;
      this.agent.strAddr = item.strAddr;
      this.agent.email = item.email;
      this.agent.city = item.city;
      this.agent.state = item.state;
      this.agent.zip = item.zip;
      this.agent.phone = item.phone;
      this.agent.id = item.id;
      this.agencyList = [];  // this should hide the applicant list div!
      this.dataChange();  // emit event for data change!
      return;
    }
    clearAgencyList() {
      this.agencyList = [];
    }

    // Toaster/Message-related methods
    showToast(msg: Message) {
      this.messageService.clear('toast');
      this.messageService.add(msg);
    }

    showInfo(myMsg: Message) {
      this.messageService.clear('info');
      this.messageService.add(myMsg);
    }

    clearAll() {
      this.messageService.clear();
    }

    checkPrevAgent(): boolean {
      const userName = this.cookieService.get('userName');
      const obj = localStorage.getItem(userName + '-lastAgency');
      if (obj) {
        return true;
      } else {
        return false;
      }
    }
  

}
